<template>
  <div>
    <!-- <InterForm @querySubmit="queryHandler" @overEmit="getDataSource" :prentType="prentType" :shopList="shopList" /> -->
    <!--    FBA -&ndash;&gt; 已发货 btns： 有 '导出发货单'、'下载装箱清单'-->
    <!--    大包 -&ndash;&gt; 已发货 btns： 有 '下载装箱清单'-->
    <!--    小包 -&ndash;&gt; 已发货 btns： 只有 '导出发货单'-->
    <InterBtnBox @refeash="getDataSource" :selectedRows="selectedRows" :singleProduct="query.singleProduct" @overEmit="getDataSource"
      :prentType="prentType" tableType="shipped" />
    <InterList :dataSource="dataSource" :total="query.total" :singleProduct="query.singleProduct" @pageChange="pageChangeCall"
      @selectChange="selectChangeCall" @change="getDataSource" tableType="shipped" @refeash="getDataSource" ref="interlist"
      :prentType="prentType" :clean="clean" :forwarder="$attrs.forwarder"></InterList>
  </div>
</template>

<script>
import InterForm from "@/views/outOfStock/internationalShipment/components/InterForm";
import InterList from "@/views/outOfStock/internationalShipment/components/InterList";
import InterBtnBox from "@/views/outOfStock/internationalShipment/components/InterBtnBox";
import { deliveryStatus, deliveryTypes } from "@/views/outOfStock/internationalShipment/tabs/index";
import { shipTask } from "@/apis/outStock";

export default {
  title: '已发货',
  name: "shipped", // 已发货
  components: {
    InterForm,
    InterList,
    InterBtnBox
  },
  props: {
    prentType: String,
    shopList: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      query: {
        current: 1,
        pageSize: 20,
        total: 0
      },
      clean: false,
      selectedRows: [],
      dataSource: []
    }
  },
  methods: {
    queryHandler: function (payload) {
      this.query = {
        ...this.query,
        ...payload,
      }
      this.query.current = 1
      this.getDataSource()
      if (this.$refs.interlist) {
        this.$refs.interlist.resetPage()
      }
    },
    pageChangeCall: function (payload) {
      const { current, pageSize } = payload;
      this.query.current = current;
      this.query.pageSize = pageSize;
      this.getDataSource()
    },
    selectChangeCall: function (rows) {
      console.log(rows)
      this.selectedRows = rows
    },
    getDataSource: function () {
      // console.log(this.query)
      // 获取列表数据
      this.selectedRows = []
      const params = {
        ...this.query,
        pageNum: this.query.current,
        deliveryStatus: deliveryStatus['shipped'],
        deliveryType: deliveryTypes[this.prentType]
      }
      this.clean = true;
      shipTask(params).then(res => {
        const { data: { total = 0, records = [] } } = res
        records.forEach(item => {
          let text = ''
          if (item.channelNo && item.logisticsChannelDTOList) {
            item.logisticsChannelDTOList.forEach(item_son => {
              if (item_son.channelNo == item.channelNo) {
                text = item_son.channelName
              }
            })
          }
          item.channelNo = text
        })
        this.dataSource = records
        this.query.total = total
        // const {}
      }).finally(_ => {
          this.clean = false;
      })
    },
  }
}
</script>

<style scoped>
</style>